import Enum from '@square/dashboard-utilities/utils/enum';
export const TenderType = new Enum('UNKNOWN', 'CARD', 'CASH', 'NO_SALE', 'OTHER', 'WALLET', 'GENERIC', 'BANK_TRANSFER', 'ZERO_AMOUNT', 'SQUARE_CAPITAL', 'EXTERNAL', 'PUSH_TENDER');